import { useQuery } from '@tanstack/react-query';
import { apiClientV2 } from '~/api/client';
import { Creator } from '~/clientApi/creator.model';

import {
  CountriesEntity,
  GendersPerAgeEntity,
  LabelValuePair,
} from './useGetIGInsights';

export const useGetSnapchatInsights = ({ id }: { id?: string }) => {
  return useQuery({
    queryKey: ['insights-snapchat', { id }],
    queryFn: () => {
      return apiClientV2
        .get<SnapchatInsights>(`/creator-snapchat-insights/${id}`)
        .then((r) => r.data);
    },
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export interface SnapchatInsights {
  id: string;
  creator: Pick<
    Creator,
    'id' | 'location' | 'echoWelcomeSeen' | 'isOnCampaign' | 'createdAt'
  >;
  email: string;
  displayName: string;
  snapUserName: string;
  profileTier: string;
  internalProfileCategory: string;
  subscriberCount: number;
  logoUrls: LogoUrls;
  city: string;
  district: string;
  website: string;
  description: string;
  category: string;
  subCategory: string;
  pipelineProfileId: string;
  metricsOnPlatformUpdatedAt: string;
  subscribers: string;
  storyAvgViewTimeMs: string;
  savedStoryAvgViewTimeMs: string;
  spotlightAvgViewTimeMs: string;
  ages?: LabelValuePair[] | null;
  genders?: LabelValuePair[] | null;
  gendersPerAge?: GendersPerAgeEntity[] | null;
  countries?: CountriesEntity[] | null;
  locales?: LabelValuePair[] | null;
  createdAt: string;
  updatedAt: string;
  createdAtAgo: string;
  updatedAtAgo: string;
  demographicsLastUpdatedAt: string;
}
interface LogoUrls {
  discover_feed_logo: DiscoverFeedLogoOrManageLogoOrMegaLogoOrOriginalLogo;
  manage_logo: DiscoverFeedLogoOrManageLogoOrMegaLogoOrOriginalLogo;
  mega_logo: DiscoverFeedLogoOrManageLogoOrMegaLogoOrOriginalLogo;
  original_logo: DiscoverFeedLogoOrManageLogoOrMegaLogoOrOriginalLogo;
}
interface DiscoverFeedLogoOrManageLogoOrMegaLogoOrOriginalLogo {
  extension: string;
  height: number;
  mime_type: string;
  path: string;
  width: number;
}
